/* Lion's Blood bundle — flag picker switches between separate shirt products,
   size picker uses the chosen product's real variants, availability-aware ATC.
   Cart integration mirrors m-product-bundle (product-bundles.js); the global
   cart-toast.js fetch interceptor takes care of the success toast. */
(function () {
  if (customElements.get('lionsblood-bundle')) return;

  /* No currency symbol by design (matches the Liquid money_without_currency
     rendering in the snippet). */
  var formatPrice = function (cents) {
    return (cents / 100).toFixed(2).replace('.', ',');
  };

  class LionsbloodBundle extends HTMLElement {
    connectedCallback() {
      var dataEl = this.querySelector('[data-bundle-data]');
      if (!dataEl) return;
      try {
        this.data = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }
      this.products = (this.data && this.data.products) || [];
      if (!this.products.length) return;

      this.mainPrice = parseInt(this.dataset.mainPrice, 10) || 0;
      this.discount = parseInt(this.dataset.discount, 10) || 0;
      this.atcLabel = this.dataset.atcLabel || 'Add to cart';
      this.soldOutLabel = this.dataset.soldOutLabel || 'Sold out';
      this.fetched = {};

      this.state = {
        index: parseInt(this.dataset.defaultIndex, 10) || 0,
        variantId: this.dataset.defaultVariantId ? parseInt(this.dataset.defaultVariantId, 10) : null,
      };

      this.els = {
        flags: Array.prototype.slice.call(this.querySelectorAll('[data-flag]')),
        groups: Array.prototype.slice.call(this.querySelectorAll('[data-size-group]')),
        shirtImgs: Array.prototype.slice.call(this.querySelectorAll('[data-shirt-img]')),
        shirtThumbs: Array.prototype.slice.call(this.querySelectorAll('[data-shirt-thumb]')),
        shirtTitle: this.querySelector('[data-shirt-title]'),
        shirtPrice: this.querySelector('[data-shirt-price]'),
        flagSelected: this.querySelector('[data-flag-selected]'),
        sizeSelected: this.querySelector('[data-size-selected]'),
        total: this.querySelector('[data-total-price]'),
        compare: this.querySelector('[data-compare-price]'),
        atc: this.querySelector('[data-add-bundle]'),
        atcText: this.querySelector('[data-atc-text]'),
        error: this.querySelector('.lb-bundle__error'),
      };

      var self = this;
      this.addEventListener('click', function (e) {
        var flag = e.target.closest('[data-flag]');
        if (flag && self.contains(flag)) return self.onFlagClick(flag);
        var size = e.target.closest('[data-size]');
        if (size && self.contains(size)) return self.onSizeClick(size);
        var atc = e.target.closest('[data-add-bundle]');
        if (atc && self.contains(atc)) return self.addBundle();
      });

      this.render();
      this.refreshAll();
    }

    product(i) {
      return this.products[typeof i === 'number' ? i : this.state.index];
    }

    variantById(id, i) {
      var p = this.product(i);
      if (!p) return null;
      return p.variants.find(function (v) {
        return v.id === id;
      }) || null;
    }

    group(i) {
      return this.els.groups.find(function (g) {
        return parseInt(g.dataset.index, 10) === i;
      });
    }

    onFlagClick(flag) {
      if (flag.disabled || flag.classList.contains('is-soldout')) return;
      var index = parseInt(flag.dataset.index, 10);
      if (index === this.state.index) return;
      this.state.index = index;
      var p = this.product();
      var firstAvailable = p.variants.find(function (v) {
        return v.available;
      });
      this.state.variantId = firstAvailable ? firstAvailable.id : null;
      this.render();
      this.refresh(index);
    }

    onSizeClick(btn) {
      if (btn.disabled || btn.classList.contains('is-soldout')) return;
      this.state.variantId = parseInt(btn.dataset.variantId, 10);
      this.render();
    }

    render() {
      var index = this.state.index;
      var p = this.product();
      var variant = this.state.variantId ? this.variantById(this.state.variantId) : null;

      this.els.flags.forEach(function (f) {
        var active = parseInt(f.dataset.index, 10) === index;
        f.classList.toggle('is-active', active);
        f.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      this.els.shirtImgs.forEach(function (img) {
        img.hidden = parseInt(img.dataset.index, 10) !== index;
      });
      this.els.shirtThumbs.forEach(function (img) {
        img.hidden = parseInt(img.dataset.index, 10) !== index;
      });
      this.els.groups.forEach(function (g) {
        g.hidden = parseInt(g.dataset.index, 10) !== index;
      });

      if (this.els.flagSelected) this.els.flagSelected.textContent = p.label || p.title;
      if (this.els.shirtTitle) this.els.shirtTitle.textContent = p.title;

      var g = this.group(index);
      if (g) {
        g.querySelectorAll('[data-size]').forEach(function (btn) {
          var active = !!variant && parseInt(btn.dataset.variantId, 10) === variant.id;
          btn.classList.toggle('is-active', active);
          btn.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      }
      if (this.els.sizeSelected) this.els.sizeSelected.textContent = variant ? variant.title : '—';

      var shirtPrice = variant ? variant.price : p.variants[0] ? p.variants[0].price : 0;
      var sum = this.mainPrice + shirtPrice;
      var total = this.discount > 0 ? Math.max(0, sum - this.discount) : sum;
      if (this.els.shirtPrice) this.els.shirtPrice.textContent = formatPrice(shirtPrice);
      if (this.els.compare) this.els.compare.textContent = formatPrice(sum);
      if (this.els.total) this.els.total.textContent = formatPrice(total);

      var ok = !!(variant && variant.available) && this.dataset.mainAvailable !== 'false';
      if (this.els.atc) {
        this.els.atc.disabled = !ok;
        this.els.atc.classList.toggle('disabled', !ok);
      }
      if (this.els.atcText) this.els.atcText.textContent = ok ? this.atcLabel : this.soldOutLabel;
    }

    /* Merge fresh availability from /products/{handle}.js into state + DOM */
    applyAvailability(i, freshVariants) {
      var p = this.product(i);
      if (!p) return;
      p.variants.forEach(function (v) {
        var fresh = freshVariants.find(function (fv) {
          return fv.id === v.id;
        });
        if (fresh) v.available = !!fresh.available;
      });
      p.available = p.variants.some(function (v) {
        return v.available;
      });

      var self = this;
      var g = this.group(i);
      if (g) {
        g.querySelectorAll('[data-size]').forEach(function (btn) {
          var v = self.variantById(parseInt(btn.dataset.variantId, 10), i);
          var available = !!(v && v.available);
          btn.disabled = !available;
          btn.classList.toggle('is-soldout', !available);
          if (available) btn.removeAttribute('aria-disabled');
          else btn.setAttribute('aria-disabled', 'true');
        });
      }
      var flag = this.els.flags.find(function (f) {
        return parseInt(f.dataset.index, 10) === i;
      });
      if (flag) {
        flag.disabled = !p.available;
        flag.classList.toggle('is-soldout', !p.available);
      }

      if (i === this.state.index) {
        var current = this.state.variantId ? this.variantById(this.state.variantId) : null;
        if (!current || !current.available) {
          var firstAvailable = p.variants.find(function (v) {
            return v.available;
          });
          this.state.variantId = firstAvailable ? firstAvailable.id : null;
        }
        this.render();
      }
    }

    refresh(i) {
      var self = this;
      var p = this.product(i);
      if (!p || this.fetched[p.handle]) return Promise.resolve();
      this.fetched[p.handle] = true;
      var routes = (window.MinimogSettings && window.MinimogSettings.routes) || {};
      var root = routes.root && routes.root !== '/' ? routes.root.replace(/\/+$/, '') : '';
      return fetch(root + '/products/' + p.handle + '.js')
        .then(function (r) {
          return r.ok ? r.json() : null;
        })
        .then(function (d) {
          if (d && d.variants) self.applyAvailability(i, d.variants);
        })
        .catch(function () {});
    }

    refreshAll() {
      var self = this;
      var chain = Promise.resolve();
      this.products.forEach(function (_, i) {
        chain = chain.then(function () {
          return self.refresh(i);
        });
      });
    }

    mainVariantId() {
      /* mode 'shirt': the fixed item is Lion's Blood, NOT the page product —
         the page's form belongs to the shirt, so never read it. */
      if (this.dataset.fixedMain === 'true') {
        return parseInt(this.dataset.mainVariantId, 10);
      }
      var input = document.querySelector('.m-main-product product-form input[name="id"], .m-main-product form [name="id"]');
      if (input && input.value) return parseInt(input.value, 10);
      return parseInt(this.dataset.mainVariantId, 10);
    }

    addBundle() {
      var self = this;
      var variant = this.state.variantId ? this.variantById(this.state.variantId) : null;
      if (!variant || !variant.available) {
        this.render();
        return;
      }
      var mainId = this.mainVariantId();
      if (!mainId) {
        this.showError('Bundle is momenteel niet beschikbaar.');
        return;
      }

      var button = this.els.atc;
      var cartDrawer = document.querySelector('m-cart-drawer');
      var settings = window.MinimogSettings || {};
      var data = {
        items: [
          { id: mainId, quantity: 1 },
          { id: variant.id, quantity: 1 },
        ],
      };
      if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
        data.sections = cartDrawer.getSectionsToRender().map(function (s) {
          return s.id;
        });
        data.sections_url = window.location.pathname;
      }

      var config;
      if (typeof window.fetchConfig === 'function') {
        config = window.fetchConfig('javascript');
      } else {
        config = { headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' } };
      }
      config.method = 'POST';
      config.body = JSON.stringify(data);

      var addUrl = (settings.routes && settings.routes.cart_add_url) || '/cart/add';
      if (button) {
        button.classList.add('is-loading');
        button.disabled = true;
      }

      fetch(addUrl, config)
        .then(function (r) {
          return r.json();
        })
        .then(function (response) {
          if (response.status) {
            self.showError(response.description || response.message || 'Toevoegen aan winkelwagen is mislukt.');
            document.dispatchEvent(new CustomEvent('product-ajax:error', { detail: { errorMessage: response.description } }));
            var p = self.product();
            if (p) {
              delete self.fetched[p.handle];
              self.refresh(self.state.index);
            }
            return;
          }
          if (settings.enable_cart_drawer && cartDrawer && typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents(response);
          }
          document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: response } }));
          if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
            window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, response);
          }
          if (!settings.use_ajax_atc) {
            window.location = (settings.routes && settings.routes.cart) || '/cart';
          }
        })
        .catch(function () {
          self.showError('Er ging iets mis bij het toevoegen aan de winkelwagen.');
        })
        .finally(function () {
          if (button) button.classList.remove('is-loading');
          self.render();
        });
    }

    showError(msg) {
      if (window.MinimogTheme && window.MinimogTheme.Notification && this.els.error) {
        window.MinimogTheme.Notification.show({
          target: this.els.error,
          method: 'appendChild',
          type: 'warning',
          message: msg,
        });
      } else if (this.els.error) {
        this.els.error.textContent = msg;
      }
    }
  }

  customElements.define('lionsblood-bundle', LionsbloodBundle);
})();
